module.exports = __webpack_public_path__ + "static/img/shushi-1.1b79b71e.png";